import { render, staticRenderFns } from "./demjansandor.vue?vue&type=template&id=e35267c2&scoped=true&class=body"
import script from "./demjansandor.vue?vue&type=script&lang=js"
export * from "./demjansandor.vue?vue&type=script&lang=js"
import style0 from "./demjansandor.vue?vue&type=style&index=0&id=e35267c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e35267c2",
  null
  
)

export default component.exports